import styled from '../../styled'
import { Typography } from '@yanolja-org/ya-com-core'

/**
 * Item component
 * author: soojin.oh
 */

// styled components
export const Container = styled.div`
  width: 100%;
  min-width: 24rem;
  height: 5.6rem;
  display: flex;
  align-items: center;
  padding: 0 2.4rem 0 2.4rem;
  ${Typography('subtitle3').regular};
  color: ${({ theme }) => theme.color.gray900};
  background: ${({ theme }) => theme.color.white};
  cursor: pointer;

  @media (hover: hover) and (pointer: fine) {
    :hover {
      background: ${({ theme }) => theme.color.gray100};
    }
  }

  :active {
    background: ${({ theme }) => theme.color.gray200};
  }

  &.selected {
    ${Typography('subtitle3').bold};
    color: ${({ theme }) => theme.color.blue600};
  }

  @media (min-width: 640px) {
    width: 50%;
    flex-wrap: wrap;
  }
`
